import React, { useEffect, useRef } from 'react';
import { Animated, Easing, ViewProps } from 'react-native';

import styles from './answer-container.style';

interface AnswerContainerProps extends ViewProps {
  isSuccess: boolean;
  isError: boolean;
  children?: React.ReactNode;
}

const AnswerContainer: React.FC<AnswerContainerProps> = ({
  children,
  style,
  isSuccess = false,
  isError = false,
  ...props
}) => {
  const x = useRef(new Animated.Value(0));
  const scale = useRef(new Animated.Value(1));

  useEffect(() => {
    if (isSuccess) {
      Animated.sequence([
        Animated.timing(scale.current, {
          toValue: 1.1,
          duration: 400,
          easing: Easing.elastic(2),
          useNativeDriver: true,
        }),
        Animated.timing(scale.current, {
          toValue: 1,
          duration: 250,
          easing: Easing.elastic(1),
          useNativeDriver: true,
        }),
      ]).start();
    }
    if (isError) {
      Animated.loop(
        Animated.sequence([
          Animated.timing(x.current, {
            toValue: 1,
            duration: 80,
            easing: Easing.elastic(1),
            useNativeDriver: true,
          }),
          Animated.timing(x.current, {
            toValue: -1,
            duration: 80,
            easing: Easing.elastic(1),
            useNativeDriver: true,
          }),
          Animated.timing(x.current, {
            toValue: 0,
            duration: 80,
            easing: Easing.elastic(1),
            useNativeDriver: true,
          }),
        ]),
        {
          iterations: 2,
        }
      ).start();
    }
  }, [isSuccess, isError]);

  const translateX = x.current.interpolate({
    inputRange: [-1, 0, 1],
    outputRange: [-10, 0, 10],
    extrapolate: 'clamp',
  });

  return (
    <Animated.View
      style={[
        styles.container,
        { transform: [{ translateX }, { scale: scale.current }] },
        style,
      ]}
      {...props}
    >
      {children}
    </Animated.View>
  );
};

export default AnswerContainer;
